// @flow

import React from 'react'
import { connect } from 'react-redux'
// $FlowFixMe
import { push } from 'connected-react-router'
// $FlowFixMe
import { reduxForm, getFormValues } from 'redux-form'
import { updateBooking } from 'src/ducks/booking'
import { Button } from 'src/theme/globalStyle'
import { BookingSummary } from 'src/components/BookingSummary'
import PaymentSummary from 'src/components/PaymentSummary'
import type { Room as RoomType, Booking as BookingType } from 'src/types'
import type { State } from 'src/types/redux'

type Props = {
  handleSubmit: Function,
  pathname: string,
  floorPreference: { value: string },
  hasKitchen: boolean,
  room: RoomType,
  booking: BookingType,
  bookingDeposit: string,
  adminFee: string
}

let SummaryForm = ({
  handleSubmit,
  pathname,
  floorPreference,
  hasKitchen,
  room,
  booking,
  bookingDeposit,
  adminFee
}: Props) => {
  const { membership, moveIn } = booking
  return (
    <form onSubmit={handleSubmit}>
      <BookingSummary moveIn={moveIn} membership={membership} booking={booking} noMargin={true} />
      <PaymentSummary
        bookingDeposit={bookingDeposit}
        adminFee={adminFee}
        noMargin={true}
        membership={membership}
      />
      <Button type="submit" uppercase>
        Book
      </Button>
    </form>
  )
}

SummaryForm = reduxForm({
  form: 'roomSelection',
  destroyOnUnmount: false,
  forceUnregisterOnUnmount: true
})(SummaryForm)

const mapStateToProps = (state: State, ownProps: Props) => {
  const { room } = ownProps
  const values = getFormValues('roomSelection')(state)
  const { occupancyType, moveIn, membershipDuration, bookingDeposit, adminFee } = values
  const moveInValue = moveIn.label
  return {
    booking: {
      membership: { ...membershipDuration },
      moveIn: moveInValue,
      bookingDeposit,
      adminFee,
      occupancyType,
      room
    }
  }
}

const mapDispatchToProps = (dispatch, ownProps: Props) => {
  return {
    onSubmit(values) {
      const { pathname, room } = ownProps
      const { occupancyType, moveIn, membershipDuration } = values
      dispatch(
        updateBooking({
          membership: { ...membershipDuration },
          moveIn,
          occupancyType,
          room
        })
      )
      dispatch(push(`${pathname}/secure`))
    }
  }
}
// $FlowFixMe
export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SummaryForm)



// WEBPACK FOOTER //
// ./src/containers/RoomDetailForm/components/SummaryForm.js